<template>
  <div class="ws-compare-merge">
    <!-- <div
      v-if="!firstData||!secondData||!firstData.length===secondData.length"
      class="ws-compare-merge__warn"
    >

      <p>
        <v-icon size="20">mdi-alert</v-icon>您已做了單一比對，無法進行全部題目比對！
      </p>
    </div> -->
    <div class="ws-compare-merge__arrow-section">
      <!-- ||!firstData.length===secondData.length -->
      <WsIconBtn
        :disabled="!firstData||!secondData"
        @click="$_onArrowClick('left')"
      >mdi-arrow-left</WsIconBtn>
      <WsIconBtn
        :disabled="!firstData||!secondData"
        @click="$_onArrowClick('right')"
      >mdi-arrow-right</WsIconBtn>
    </div>
    <WsCompareMergeItem
      :ref="`wsCompareMergeItem${firstDataIndex}`"
      v-for="(firstDataItem,firstDataIndex) in firstData"
      :key="firstDataIndex"
      :titleFirst="titleFirst"
      :titleSecond="titleSecond"
      :firstValue.sync="firstData[firstDataIndex]"
      :secondValue.sync="secondData[firstDataIndex]"
      :inputFields="inputFields"
      :compareField="compareField"
      @select="$_onSelect($event, firstDataIndex)"
    ></WsCompareMergeItem>
  </div>
</template>

<script>
export default {
  props: {
    titleFirst: {
      type: String,
    },
    titleSecond: {
      type: String,
    },
    firstData: {
      type: Array,
    },
    secondData: {
      type: Array,
    },
    inputFields: {
      type: Object,
    },
    compareField: {
      type: String,
    },
  },
  methods: {
    $_onArrowClick(direct) {
      for (let i = 0; i < this.firstData.length; i++) {
        this.$refs[`wsCompareMergeItem${i}`][0].$_onArrowClick(direct);
      }
    },
    $_onSelect(direct, firstDataIndex) {
      this.$set(this.firstData[firstDataIndex], 'isSelected', direct === 'left');
      this.$set(this.secondData[firstDataIndex], 'isSelected', direct !== 'left');
    }
  },
};
</script>

<style lang="scss">
@import "../assets/scss/ws-compare-merge.scss";
</style>